import { TLegacyGroup } from "../api/types/Group";

export const groupDisplayName = (group: TLegacyGroup) => {
  return `${group?.displayname || group?.groupid}${group?.description ? ` | ${group.description}` : ""}`;
}